import React from 'react';
import ClinicalNoteSection from '../../../../global/component/ClinicalNote/ClinicalNoteSection';
import { ClinicalNoteType } from '../../../../global/entities/ClinicalNote/ClinicalNote';

interface CounsellingNoteSectionProps {
    patientId?: string | number;
    patientName?: string | null;
    patientDateOfBirth?: string | null;
}

const CounsellingNoteSection: React.FC<CounsellingNoteSectionProps> = (props) => (
    <ClinicalNoteSection
        config={{
            noteType: ClinicalNoteType.Counselling,
            i18nPrefix: 'counsellingNote',
            editRouteSegment: 'counsellingNote',
            showSendToAssistant: true,
            supportsDualAck: true,
        }}
        {...props}
    />
);

export default CounsellingNoteSection;
